import { motion } from "framer-motion";
import { Instagram } from "lucide-react";

const PROFILE_URL = "https://instagram.com/tlfdesignz";

const WORKS = [
  {
    title: "Branded Hoodies",
    img: "https://images.unsplash.com/photo-1648466104157-53bb5b191c72?crop=entropy&cs=srgb&fm=jpg&w=800&q=60",
  },
  {
    title: "Laminated Stickers",
    img: "https://images.unsplash.com/photo-1705039228815-a54991a30167?crop=entropy&cs=srgb&fm=jpg&w=800&q=60",
  },
  {
    title: "Embroidered Caps",
    img: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?auto=format&fit=crop&w=800&q=60",
  },
  {
    title: "Glossy Mugs",
    img: "https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?auto=format&fit=crop&w=800&q=60",
  },
];

const InstagramFeed = ({
  works = WORKS,
  kicker = "Portfolio",
  heading = "Fresh From The Studio",
  testid = "instagram",
}) => (
  <section className="border-t border-white/10 py-24" data-testid={`${testid}-section`}>
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.4em] text-brand-magenta">
            {kicker}
          </p>
          <h2 className="mt-2 font-display text-4xl font-black uppercase tracking-tight text-white sm:text-5xl">
            {heading}
          </h2>
        </div>
        <a
          href={PROFILE_URL}
          target="_blank"
          rel="noreferrer"
          data-testid={`${testid}-follow-link`}
          className="flex items-center gap-2 border border-brand-magenta/60 px-5 py-3 font-display text-sm font-bold uppercase tracking-widest text-brand-magenta transition-colors hover:bg-brand-magenta hover:text-white"
        >
          <Instagram className="h-4 w-4" /> @tlfdesignz
        </a>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {works.map((w, i) => (
          <motion.a
            key={w.title}
            href={PROFILE_URL}
            target="_blank"
            rel="noreferrer"
            data-testid={`${testid}-post-${i}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: i * 0.08, duration: 0.5 }}
            className="group relative block overflow-hidden border border-white/10"
          >
            <img
              src={w.img}
              alt={w.title}
              loading="lazy"
              className="aspect-[3/4] w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink/90 to-transparent p-4">
              <p className="font-display text-lg font-bold uppercase text-white">{w.title}</p>
              <p className="font-mono text-[9px] uppercase tracking-widest text-brand-cyan">
                TLF DESIGNZ Studio Work
              </p>
            </div>
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-ink/80 opacity-0 backdrop-blur-sm transition-opacity duration-300 group-hover:opacity-100">
              <Instagram className="h-8 w-8 text-white" />
              <p className="font-display text-sm font-bold uppercase tracking-widest text-white">
                View on @tlfdesignz
              </p>
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);

export default InstagramFeed;
